export const PROJECTS_UPDATED_EVENT = 'webcert:projects-updated'
